<router-outlet></router-outlet>

<footer style="background-color: #F23064; color: white; text-align: center;">
    <div class="row g-0">
        <div class="col-12">
            <p>{{ 'app.copyright' | t:{ version: '1.2.10' } }}</p>
        </div>
    </div>
</footer>
